export const RESPAWN_COOLDOWN_MS = 30_000;

export interface ShouldShowSpawnArgs {
  tickSpawnId: string | null;
  shownSpawnId: string | null;
  claimed: ReadonlySet<string>;
  cooldownUntil: number;
  now: number;
}

export function shouldShowSpawn(args: ShouldShowSpawnArgs): boolean {
  const { tickSpawnId, shownSpawnId, claimed, cooldownUntil, now } = args;
  if (!tickSpawnId || shownSpawnId) return false;
  if (claimed.has(tickSpawnId)) return false;
  if (now < cooldownUntil) return false;
  return true;
}
